<template>
  <LadResizer
    container-class="lad-reviews"
    :max-sm-width="540"
    :max-xs-width="420"
  >
    <LadReviewsProduct v-if="isProduct" :uuid="uuid" />
  </LadResizer>
</template>

<script>
import { LadReviewsProduct } from './components'

export default {
  name: 'LadReviews',
  components: {
    LadResizer: () =>
      import(/* webpackChunkName: "lad-resizer" */ '@/components/resizer'),
    LadReviewsProduct,
  },
  props: {
    type: { type: String, default: 'product' },
    uuid: { type: String, default: '' },
  },
  computed: {
    isProduct() {
      return this.type === 'product'
    },
  },
}
</script>
